import React from 'react';
import { EMPTY_GUID } from './Constants';

const defaultGlobalData: GlobalData = {
    tenant: { name: '', logoPath: '', contactSummary: '' },
    communityKey: EMPTY_GUID,
    micrositeKey: EMPTY_GUID,
    micrositeGroupName: '',
    canUserEditPage: false,
    isUserAuthenticated: false,
    isUserSuperAdmin: false,
    isUserSiteAdmin: false,
    isUserCommunityAdmin: false,
    isUserCommunityModerator: false,
    currentUserContactKey: EMPTY_GUID,
    isTopicCommunity: false,
    isSelfModerationCommunity: false,
    useCommunityWebApi: false,
    hlTest: undefined,
    colorPickerDefaults: {
        primaryColor: null,
        textOnPrimary: null,
        secondaryColor: null,
        textOnSecondary: null,
        linkColor: null,
        linkHoverColor: null,
        footerBackgroundColor: null,
        footerTextColor: null
    },
    loginUrl: '',
    hasTranslationsProduct: false
};

const GlobalDataContext = React.createContext<GlobalData>(defaultGlobalData);
GlobalDataContext.displayName = 'GlobalDataContext';
export { GlobalDataContext };
